import { FC } from "react";
import { useTranslation } from "../../../explorer/hooks/useTranslation";
import { Box } from "@mui/material";
import {
  DialogContentStyled,
  TypographyStyled,
  TypographyStyled2,
  TypographySubTitle,
} from "./CommonDialog.style";

type TCommonDialogSubTitle = {
  useSubTitle: boolean;
  dialogContentLabel?: string;
  children?: JSX.Element;
};

const CommonDialogSubTitle: FC<TCommonDialogSubTitle> = (props) => {
  const { useSubTitle, dialogContentLabel, children } = props;
  const { t } = useTranslation();

  return useSubTitle ? (
    <DialogContentStyled dividers>
      {dialogContentLabel && (
        <TypographySubTitle>{t(dialogContentLabel)}</TypographySubTitle>
      )}
      {children}
    </DialogContentStyled>
  ) : (
    <DialogContentStyled dividers>
      {dialogContentLabel && (
        <TypographyStyled2>{t(dialogContentLabel)} </TypographyStyled2>
      )}
      {children}
    </DialogContentStyled>
  );
};
export default CommonDialogSubTitle;
